import { NavigationSection } from "@components/navigation/NavigationSection"

import { APPLICATION_SECTION, APPLICATION_ADVANCED_SECTION } from "@constants/navigations"
import { AnimatePresence, motion } from "framer-motion"

import STACKED_VERTESIA_ICON from "@assets/vertesia-stacked.png"
import VERTESIA_ICON from "@assets/vertesia-icon.png"
import { Sidebar, SidebarContent, SidebarFooter, useSidebar } from "@ui/sidebar"

export function ApplicationSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { state } = useSidebar()
    return (
        <Sidebar collapsible="icon" className="top-[var(--header-height)] !h-[calc(100svh-var(--header-height))]" {...props}>
            <SidebarContent>
                <NavigationSection section={APPLICATION_SECTION} />
                <NavigationSection section={APPLICATION_ADVANCED_SECTION} />
            </SidebarContent>
            <SidebarFooter>
                <div className="flex items-end justify-center w-full h-[60px] relative">
                    <AnimatePresence mode="wait">
                        {
                            state === "expanded" ? (
                                <motion.img
                                    key="stacked"
                                    src={STACKED_VERTESIA_ICON}
                                    alt="Vertesia logo"
                                    initial={{ opacity: 0, scale: 0.8, width: 40 }}
                                    animate={{ opacity: 1, scale: 1, width: 130 }}
                                    exit={{ opacity: 0, scale: 0.8 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="absolute"
                                    style={{ width: 130 }}
                                />
                            ) : (
                                <motion.img
                                    key="icon"
                                    src={VERTESIA_ICON}
                                    alt="Vertesia logo"
                                    initial={{ opacity: 0, scale: 0.8, width: 130 }}
                                    animate={{ opacity: 1, scale: 1, width: 40 }}
                                    exit={{ opacity: 0, scale: 0.8 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="absolute"
                                    style={{ width: 40 }}
                                />
                            )
                        }
                    </AnimatePresence>
                </div>
            </SidebarFooter>
        </Sidebar>
    )
}
